import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, CssBaseline, ThemeProvider } from '@mui/material'
import theme from './theme/theme'
import { loadKpiConfig }             from './reducers/kpiConfigReducer'
import { loadFilterMatrix } from './reducers/lockdownReducer'
import { setLockdownContext }        from './reducers/filtersReducer'
import { clearKpiData }              from './reducers/kpiDataReducer'
import { applyAndFetchKpiData }      from './actions/kpiDataActions'

import LockdownKPIDashboardEmptyState     from './components/layout/LockdownKPIDashboardEmptyState'
import LockdownKPIDashboardLockdownPicker from './components/filters/LockdownKPIDashboardLockdownPicker'
import LockdownKPIDashboardFilterBar      from './components/filters/LockdownKPIDashboardFilterBar'
import LockdownKPIDashboardKpiGrid        from './components/charts/LockdownKPIDashboardKpiGrid'
import LockdownKPIDashboardLegend         from './components/charts/LockdownKPIDashboardLegend'

export default function App() {
  const dispatch = useDispatch()
  const selected = useSelector(s => s.lockdown.selected)
  const [pickerOpen, setPickerOpen] = useState(false)
  const [showMarks,  setShowMarks]  = useState(true)
  const [showLegend, setShowLegend] = useState(false)
  const gridRef = useRef(null)

  // Load KPI config on mount
  useEffect(() => {
    dispatch(loadKpiConfig())
  }, []) // eslint-disable-line

  const handleLockdownConfirmed = useCallback((detail) => {
    dispatch(setLockdownContext({
      technology: detail.technology,
    }))
    dispatch(clearKpiData())
    dispatch(loadFilterMatrix({ id: detail.lockdownId, tech: detail.technology, dateFrom: null, dateTo: null }))
    dispatch(applyAndFetchKpiData())
  }, [dispatch])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
        <LockdownKPIDashboardLockdownPicker
          open={pickerOpen}
          onClose={() => setPickerOpen(false)}
          onConfirm={handleLockdownConfirmed}
        />

        {!selected ? (
          <LockdownKPIDashboardEmptyState onBrowse={() => setPickerOpen(true)} />
        ) : (
          <>
            {/* Filter bar — full width */}
            <Box sx={{ flexShrink: 0 }}>
              <LockdownKPIDashboardFilterBar
                onOpenPicker={() => setPickerOpen(true)}
                showMarks={showMarks}
                onToggleMarks={() => setShowMarks(v => !v)}
                showLegend={showLegend}
                onToggleLegend={() => setShowLegend(v => !v)}
                gridRef={gridRef}
                lockdownTitle={selected?.lockdownName}
              />
            </Box>

            {/* Main area: charts + right legend panel */}
            <Box sx={{ display: 'flex', overflow: 'hidden', height: 'calc(100vh - 130px)' }}>
              <Box sx={{ flex: 1, minWidth: 0, p: '12px 16px', overflowY: 'auto' }}>
                <LockdownKPIDashboardKpiGrid showMarks={showMarks} gridRef={gridRef} />
              </Box>
              <LockdownKPIDashboardLegend open={showLegend} onToggle={() => setShowLegend(v => !v)} />
            </Box>
          </>
        )}
      </Box>
    </ThemeProvider>
  )
}
